import { render, staticRenderFns } from "./RegistroTrabajador.vue?vue&type=template&id=c3ff341e&scoped=true&"
import script from "./RegistroTrabajador.vue?vue&type=script&lang=js&"
export * from "./RegistroTrabajador.vue?vue&type=script&lang=js&"
import style0 from "./RegistroTrabajador.vue?vue&type=style&index=0&id=c3ff341e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ff341e",
  null
  
)

export default component.exports